// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var normalizeModifierOrder = function (params) {
    return function (order) {
        var orderSpecified = Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(order);
        var isUnspecified = function (modifierId) {
            return !Data_Set.member(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(modifierId)(orderSpecified);
        };
        var existing = Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(params.categoryModifiers)(params.productModifiers));
        var divisibilityMatches = function (modifierId) {
            return Data_Maybe.maybe(false)(function (modifier) {
                return Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "divisible";
                    }
                })()))(Type_Proxy["Proxy"].value)(modifier) === params.divisible;
            })(Restaumatic_Menu_V2_MenuCatalogue.lookupModifier(params.catalogue)(modifierId));
        };
        return Data_Array.nub(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Array.filter(function (v) {
            return Data_Set.member(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v)(existing);
        })(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Array.filter(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(isUnspecified)(divisibilityMatches))(params.categoryModifiers))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Array.filter(divisibilityMatches)(order))(Data_Array.filter(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(isUnspecified)(divisibilityMatches))(params.productModifiers)))));
    };
};
export {
    normalizeModifierOrder
};
//# sourceMappingURL=index.js.map
